/** Atributo em regiões que podem rolar com o sheet/modal aberto (ex.: conteúdo do modal). */
export const SCROLL_LOCK_SCROLLABLE_ATTR = "data-scroll-lock-scrollable";

let lockCount = 0;
let savedScrollY = 0;

function applyBodyScrollLock(): void {
  savedScrollY = window.scrollY;
  document.documentElement.style.overflow = "hidden";
  document.body.style.overflow = "hidden";
}

function releaseBodyScrollLock(): void {
  document.documentElement.style.overflow = "";
  document.body.style.overflow = "";
  window.scrollTo(0, savedScrollY);
}

/** Remove travas de scroll órfãs (lockCount já zerado, estilos ainda no body). */
export function resetOrphanedBodyScrollLock(): void {
  if (typeof document === "undefined" || lockCount > 0) {
    return;
  }
  const hasOrphanedLock =
    document.body.style.overflow === "hidden" ||
    document.documentElement.style.overflow === "hidden";
  if (!hasOrphanedLock) {
    return;
  }
  releaseBodyScrollLock();
}

/** Bloqueia scroll da página; suporta vários overlays abertos (contador). */
export function acquireBodyScrollLock(): () => void {
  if (typeof document === "undefined") {
    return () => {};
  }
  if (lockCount === 0) {
    applyBodyScrollLock();
  }
  lockCount += 1;
  return () => {
    if (lockCount <= 0) {
      return;
    }
    lockCount -= 1;
    if (lockCount === 0) {
      releaseBodyScrollLock();
    }
  };
}
